import { z } from "zod"
import { default as DomainEnvironment } from "../../domain/Environment.js"

/**
 * @description
 *	The schema of {@link Environment} type.
 */
export const EnvironmentSchema = z.enum(DomainEnvironment)

/**
 * @description
 *	An environment name.
 */
export type Environment = z.infer<typeof EnvironmentSchema>
